import { useMemo } from 'react'
import { Navigate, useParams } from 'react-router-dom'

export default function InviteRedirect() {
  const { code } = useParams()

  const target = useMemo(() => {
    const safeCode = encodeURIComponent(code ?? '')
    return `/registro?invite=${safeCode}`
  }, [code])

  return <Navigate to={target} replace />
}
